import { render, staticRenderFns } from "./pages19.vue?vue&type=template&id=72ab1496&scoped=true&"
import script from "./pages19.vue?vue&type=script&lang=js&"
export * from "./pages19.vue?vue&type=script&lang=js&"
import style0 from "./pages19.vue?vue&type=style&index=0&id=72ab1496&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ab1496",
  null
  
)

export default component.exports